import React from "react";
import { MessageCircle } from "lucide-react";
import { company } from "../../mock";

const WhatsAppFab = () => {
  const link = `https://wa.me/${company.whatsapp}?text=${encodeURIComponent("Hello " + company.name + ", I would like to enquire about your products.")}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-lg shadow-green-600/40 flex items-center justify-center pulse-soft"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};

export default WhatsAppFab;
